var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFadCaretRight = function SvgFadCaretRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.664 171.679c-.237 15.682 17.82 24.506 29.182 12.927 11.362-11.578 36.834-37.936 44.298-45.267 7.463-7.331 6.168-14.788 0-21.574-6.17-6.786-31.912-34.205-43.427-45.614C107.2 60.743 88.9 68.868 88.9 84.321s0 71.675-.237 87.358z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.273 170.4c-1.562 1.57-2.82 1.055-2.808-1.162l.427-82.445c.012-2.21 1.28-2.72 2.82-1.152l38.874 39.606a4.053 4.053 0 0 1-.03 5.693l-39.283 39.46z",
    fill: "#FFF"
  }))));
};
export { SvgFadCaretRight as ReactComponent };
export default __webpack_public_path__ + "static/media/fad-caret-right.4814a656.svg";